import React from 'react'
import Box from '@mui/material/Box'
import Paper from "@mui/material/Paper"
import FormControl from "@mui/material/FormControl"
import TextField from "@mui/material/TextField"
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import CircularProgress from "@mui/material/CircularProgress"
import MenuItem from "@mui/material/MenuItem"
import InputLabel from "@mui/material/InputLabel"
import Select from "@mui/material/Select"

import config from '../../config'
import { Context as SalesChannelContext } from '../../contexts/SalesChannels'
import { Context as NotificationsContext } from '../../contexts/Notifications'
import DropZone from '../../components/Dropzone'

const failedDownloadSnack = 'Requisitions-failedDownloadSnack'

const Requisitions = () => {
	const [disabled, setDisabled] = React.useState(null)
	const [month_modifier, setMonthModifier] = React.useState(1.5)
	const [selected_month, setSelectedMonth] = React.useState("0")
	const [percentage_modifier, setPercentageModifier] = React.useState(0)

	const [paymentsFiles, setPaymentsFiles] = React.useState([])
	const [stocksFiles, setStocksFiles] = React.useState([])
	const [shortagesFiles, setShortagesFiles] = React.useState([])
	const [clear, setClear] = React.useState(false)

	React.useEffect(() => {
		clear && setClear(false)
	}, [clear])
	const paymentsFlag = paymentsFiles.length > 0
	const stocksFlag = stocksFiles.length > 0
	const shortagesFlag = shortagesFiles.length > 0

	const { requisitions } = React.useContext(SalesChannelContext).events
	const {createSnack, openSnack, deleteSnack} = React.useContext(NotificationsContext)

	React.useEffect(() => {
		createSnack(failedDownloadSnack, {message: "Falló la generación de requisiciones"})
		return () => deleteSnack(failedDownloadSnack)
	}, [])

	const onError = () => {
		setDisabled(false)
		openSnack(failedDownloadSnack)
	}
	
	const downloadFile = (res) => {
		console.log("downloading paymentsFile from source: ", config.api_url+res)
		window.open(config.api_url+res, "_blank")
		setDisabled(false)
	}	

	const submitFile = e => {
		e.stopPropagation()
		setDisabled( true)
		const data = new FormData()
		data.append("payments", paymentsFiles[0])
		stocksFlag && data.append("stocks", stocksFiles[0])
		shortagesFlag && data.append("shortages", shortagesFlag[0])
		data.append("month_modifier", month_modifier)
		data.append("selected_month", selected_month)
		data.append("percentage_modifier", percentage_modifier)
		requisitions.create(data, downloadFile, onError)
	}
	return (
		<Stack direction={{'flexDirection':"column", justifyContent:'center', alignItems:'center', paddingTop:'15px'}}>
			{paymentsFlag &&
				<Box sx={{display:'flex', justifyContent:'flex-start', alignItems:'center', flexDirection:'row', flexWrap:'wrap'}}>
					<FormControl onClick={e => e.stopPropagation()} sx={{ m: 1, width: '25ch' }}>
						<TextField
							variant="outlined" 
							label="Multiplicador mensual" 
							name="month_modifier"
							value={month_modifier}
							onChange={e => !isNaN(Number(e.target.value)) && setMonthModifier(Number(e.target.value))}
						/>
					</FormControl>
					<FormControl onClick={e => e.stopPropagation()} sx={{ m: 1, width: '25ch' }}>
						<TextField
							variant="outlined" 
							label="Modificador porcentual" 
							name="percentage_modifier"
							value={percentage_modifier}
							onChange={e => !isNaN(Number(e.target.value)) && setPercentageModifier(Number(e.target.value))}
						/>
					</FormControl>
					<FormControl sx={{ m: 1, width: '25ch' }}>
						<InputLabel id="monthselector">Selecciona Mes</InputLabel>
						<Select
							labelId="monthselector"
							name="selected_month"
							label="monthselector"
							value={selected_month}
							onChange={e => !isNaN(Number(e.target.value)) && setSelectedMonth(Number(e.target.value))}
							defaultValue="0"
							>
		        			<MenuItem value="0">Ninguno</MenuItem><MenuItem value="1">Enero</MenuItem><MenuItem value="2">Febrero</MenuItem><MenuItem value="3">Marzo</MenuItem><MenuItem value="4">Mayo</MenuItem><MenuItem value="5">Abril</MenuItem><MenuItem value="6">Junio</MenuItem><MenuItem value="7">Julio</MenuItem><MenuItem value="8">Agosto</MenuItem><MenuItem value="9">Septiembre</MenuItem><MenuItem value="10">Octubre</MenuItem><MenuItem value="11">Noviembre</MenuItem><MenuItem value="12">Diciembre</MenuItem>
						</Select>
					</FormControl>
				</Box>
			}
			<div style={{
				display: 'flex',
				justifyContent: "center",
				margin: 'auto',
				flexWrap: 'wrap',
				flexDirection: "column",
				minWidth: 400,
			}}>
				<Paper sx={{ cursor: paymentsFlag?'auto':'pointer', position: 'relative', minWidth:"200px", minHeight: '60x', display: "flex", justifyContent: "space-around", alignItems: "center", flexDirection: "column",padding: "15px"}}>
				  <DropZone setFiles={setPaymentsFiles} accept='.csv' clear={clear} waitTitle="Reporte de Pagos"/>
				</Paper>
				<Paper sx={{ cursor: stocksFlag?'auto':'pointer', position: 'relative', minWidth:"200px", minHeight: '60x', display: "flex", justifyContent: "space-around", alignItems: "center", flexDirection: "column",padding: "15px"}}>
				  <DropZone setFiles={setStocksFiles} accept={['.tsv', '.txt']} clear={clear} waitTitle="Reporte de Reabastecimiento de Inventario"/>
				</Paper>
				<Paper sx={{ cursor: shortagesFlag?'auto':'pointer', position: 'relative', minWidth:"200px", minHeight: '60x', display: "flex", justifyContent: "space-around", alignItems: "center", flexDirection: "column",padding: "15px"}}>
				  <DropZone setFiles={setShortagesFiles} accept='.csv' clear={clear} waitTitle="Reporte Diario de Inventario"/>
				</Paper>
			</div>
			<Button disabled={!paymentsFlag || disabled} onClick={submitFile} variant="contained" color="primary" sx={{width:'200px', marginTop:'15px'}}>
				{disabled?<CircularProgress size={27}/>:'Generar requisiciones'}
			</Button>
		</Stack>
	)
}

export default Requisitions
